const KEY = "un_safe_mode_v1";

export const DEFAULT_SAFE_MODE = {
  protectChoices: true,
  protectFinances: false,
  getHome: true,
  callPerson: false,
  contactName: "",
  contactPhone: "",
  note: "",
  transportPlan: "",
  duration: "tonight",
  saferTonight: false,
  nightIntention: "",
  checkInAt: "",
  essentialsNote: "",
  madeItHomeAt: null,
  updatedAt: null,
};

export const getSafeMode = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || "null");
    return parsed && typeof parsed === "object" ? { ...DEFAULT_SAFE_MODE, ...parsed } : DEFAULT_SAFE_MODE;
  } catch {
    return DEFAULT_SAFE_MODE;
  }
};

export const saveSafeMode = (value) => {
  const next = { ...DEFAULT_SAFE_MODE, ...value, updatedAt: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};
